export default "__VITE_ASSET__2e6909b0__"